import React from 'react';
import ContactPage from './ContactPage';

// Contact Support uses the same component as Contact but with different title
const ContactSupportPage = () => {
  return <ContactPage isSupport={true} />;
};

export default ContactSupportPage;

